module.exports = __webpack_public_path__ + "d7711aaef2dcdb6028f08057e874ed46.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/2015-OPI-Logo-Long.png
// module id = 250
// module chunks = 1